import { render, staticRenderFns } from "./ExcretionGraph1D.vue?vue&type=template&id=2969059e&scoped=true&"
import script from "./ExcretionGraph1D.vue?vue&type=script&lang=js&"
export * from "./ExcretionGraph1D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969059e",
  null
  
)

export default component.exports